/**
 * @overview 文件上传公共逻辑
 *
 * @author  huojinzhao
 */

import { $http } from "@/utils";

export const QINIU_ACTION = "https://upload.qiniup.com/";
export const QINIU_BUCKET = "https://oa-statics.caihonggou.com";

function serverUpload(url, {
  file,
  key = "file",
  payload = {},
} = {}) {
  if (!file) throw new Error("$upload.serverUpload报错：缺少上传文件！");
  if (!(file instanceof File)) throw new Error("$upload报错：上传文件的参数不是文件类型！");

  const formData = new FormData();

  formData.append(key, file);

  Object.keys(payload)
    .forEach(itemKey => formData.append(itemKey, payload[itemKey]));

  return $http.post(url, formData);
}

function filterQiniuTokenParam(file, mode = "type") {
  const paramMap = {
    type: typeFile => ({
      postfix: typeFile.name.split(".").pop(),
      uri: "/upload/token",
    }),
    name: nameFile => ({
      postfix: nameFile.name,
      uri: "/resource/upload_token",
    }),
  };

  return paramMap[mode](file);
}

function fetchQiniuToken(file, mode) {
  const param = filterQiniuTokenParam(file, mode);

  return $http.get(`${param.uri}/${param.postfix}`);
}

function qiniuUpload(file, mode) {
  return fetchQiniuToken(file, mode)
    .then(({ token, key }) => {
      const data = { file, payload: { token, key } };

      return serverUpload(QINIU_ACTION, data);
    })
    .then(({ key: qkey }) => ({ key: qkey, url: `${QINIU_BUCKET}/${qkey}` }));
}

export default {
  serverUpload,
  fetchQiniuToken,
  qiniuUpload,
};
